import React, { useState } from 'react';

// Griglia di selezione per le risposte multiple (SAL 30/10). Un clic seleziona
// un'opzione, un secondo clic la toglie. «Invia» manda tutte le scelte insieme;
// per rispondere a parole resta la casella di testo.
export default function GrigliaScelte({ griglia, onInvia, disabled }) {
  const [scelte, setScelte] = useState([]);
  if (!griglia.opzioni?.length) return null;

  const cambia = (id) =>
    setScelte((prima) => (prima.includes(id) ? prima.filter((s) => s !== id) : [...prima, id]));

  const invia = () => {
    const riepilogo = griglia.opzioni.filter((o) => scelte.includes(o.id)).map((o) => o.label).join(', ');
    onInvia(scelte, riepilogo);
  };

  return (
    <div className="sa-griglia" role="group" aria-label="Seleziona una o più risposte">
      <div className="sa-griglia-scelte">
        {griglia.opzioni.map((o) => (
          <button
            key={o.id}
            type="button"
            aria-pressed={scelte.includes(o.id)}
            className={`sa-griglia-scelta${scelte.includes(o.id) ? ' is-scelto' : ''}`}
            disabled={disabled}
            onClick={() => cambia(o.id)}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="sa-griglia-azioni">
        <span className="sa-griglia-conteggio">{scelte.length} selezionate</span>
        <button type="button" className="btn btn-primary" disabled={disabled || !scelte.length} onClick={invia}>
          Invia
        </button>
      </div>
    </div>
  );
}
